import React from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import { useStores } from "../hooks/use-stores";

const useStyles = makeStyles((theme) => ({
    intro: {
        whiteSpace: "pre-wrap",
        overflowWrap: "break-word",
    },
    action: {
        marginTop: theme.spacing(1.5),
        marginBottom: theme.spacing(1.5),
    },
    list: {
        margin: 0,
        paddingInlineStart: 20,
    },
    item: {
        marginBottom: theme.spacing(1),
        overflowWrap: "break-word",
    },
    note: {
        marginTop: theme.spacing(1.5),
        overflowWrap: "break-word",
    },
}));

export default function Core4InfoContent({ to }) {
    const classes = useStyles();
    const { t } = useTranslation();
    const history = useHistory();
    const { commonStore } = useStores();

    const openCore4 = () => {
        commonStore.cancelConfirm();
        history.push(to);
    };

    return (
        <Box>
            <Typography className={classes.intro}>{t("starfish:core4.popup_intro")}</Typography>
            <Button className={classes.action} color="primary" variant="contained" onClick={openCore4}>
                {t("starfish:core4.popup_link")}
            </Button>
            <ol className={classes.list}>
                {[1, 2, 3, 4].map((n) => (
                    <Typography component="li" key={n} className={classes.item}>
                        {t(`starfish:core4.requirement_${n}`)}
                    </Typography>
                ))}
            </ol>
            <Typography variant="body2" className={classes.note}>{t("starfish:core4.pv_note")}</Typography>
        </Box>
    );
}
